import React, {type FC} from 'react'
import {Loader} from 'uikit'
import {ModalWrap} from '../ModalWrap'
import styles from './LoaderModal.scss'

export const LoaderModal: FC<{}> = () => {

  return (
    <ModalWrap classes={{modal: styles.wrapper}}>
      <Loader />
    </ModalWrap>
  )
}
